'use client';

import {
  FileTypeConfig,
  LandingFeatures,
  LandingHero,
  LandingUseCases,
  FeatureItem,
} from '../_components';
import { BookOpen, Layers, Type, Image, Navigation } from 'lucide-react';

const epubConfig: FileTypeConfig = {
  type: 'epub',
  title: '在线翻译 EPUB 电子书·保持阅读体验',
  subtitle: '小说、教材、技术书籍的专业翻译解决方案',
  description: '保留目录结构、图片、样式的完整电子书翻译',
  icon: <BookOpen className="w-full h-full" />,
  gradientFrom: '#8b5cf6',
  gradientTo: '#7c3aed',
  accentColor: 'violet',
  particleColors: ['#8b5cf6', '#a78bfa', '#c4b5fd'],
  accept: {
    'application/epub+zip': ['.epub'],
  },
  stats: {
    users: '20万+',
    accuracy: '99.4%',
    files: '80万+',
  },
};

const epubFeatures: FeatureItem[] = [
  {
    icon: Navigation,
    title: '目录完整保留',
    description: '章节导航、书签结构完整保持，阅读体验不变',
  },
  {
    icon: Type,
    title: '排版样式保持',
    description: '字体、段落、标题样式精准还原',
  },
  {
    icon: Image,
    title: '图片内容保留',
    description: '插图、封面、图表完整保持原位',
  },
  {
    icon: Layers,
    title: '多章节处理',
    description: '长篇书籍一次翻译，所有章节同步处理',
  },
];

const epubUseCases = [
  '小说翻译',
  '技术书籍',
  '教材教辅',
  '学术专著',
  '杂志期刊',
  '个人出版',
];

const EpubPage = () => {
  return (
    <div className="w-full">
      <LandingHero config={epubConfig} />
      <LandingFeatures
        title="EPUB 专属优势"
        features={epubFeatures}
        gradientFrom={epubConfig.gradientFrom}
        gradientTo={epubConfig.gradientTo}
      />
      <LandingUseCases
        useCases={epubUseCases}
        gradientFrom={epubConfig.gradientFrom}
        gradientTo={epubConfig.gradientTo}
      />
    </div>
  );
};

export default EpubPage;
